var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"cols":_vm.block.cols,"xs":_vm.block.colsxs,"sm":_vm.block.colssm,"md":_vm.block.colsmd,"lg":_vm.block.colslg,"xl":_vm.block.colsxl,"offset":_vm.block.offset}},[_c('Dropbox',{attrs:{"files":_vm.form,"label":_vm.block.label}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }